// import './05-objects/slider';
import './05-objects/menu';
import './05-objects/news';
import './05-objects/gallery';
import './05-objects/works-gallery';
// import './05-objects/events' ;

